module.exports = __webpack_public_path__ + "img/48.eda50d94.png";